<template>
  <div
    class="handicap-box"
    v-if="Object.keys(data).length"
  >
    <div
      class="left-info"
      :style="{width:/MRI/.test(type_code)? '25%' : '23%'}"
    >
      <ul class="base-info">
        <!-- 股票名称 -->
        <li
          class="title"
          :title="data['prod_name']"
        >{{data['prod_name']}}</li>
        <!-- 股票代码 -->
        <li class="title">{{data['prod_code'] && data['prod_code'].split('.')[0]}}</li>
        <!-- <li class="date_color">{{data['market_date']|dateFormat}} {{data['data_timestamp']|timeFormat}}</li> -->
      </ul>
      <ul class="px-change-info">
        <!-- 最新价 -->
        <li :style="{color:!isFF?fontColor(data['last_px'], data['preclose_px']):fontColor(data['last_px'], data['prev_settlement'])}">
          <span
            style="font-size:24px;"
            :class="[{'bg-red':data['last_px_bgc']==1},{'bg-green':data['last_px_bgc']==2},{'bg-none':data['last_px_bgc']==0}]"
          >
            {{data['last_px']!==0?dot(data['last_px']):'--'}}</span>
          <!-- <i :class="[data['last_px']>data['preclose_px']?'up_arrow':'down_arrow']"></i> -->
        </li>
        <li>
          <!-- 涨跌额 -->
          <span :style="{color:fontColor(data['px_change'], 0)}">
            {{data['last_px']>0?dot(data['px_change']):'--'}}</span>
          <!-- 涨跌幅 -->
          <span :style="{color:!isFF?fontColor(data['last_px'], data['preclose_px']):fontColor(data['last_px'], data['prev_settlement'])}">
            {{data['last_px']>0?dot(data['px_change_rate'],2):'--'}}<span v-if="data['last_px']>0">%</span></span>
        </li>
      </ul>
    </div>
    <!-- 行情信息 -->
    <div class="right-info">
      <ul>
        <li>Today <span :style="{color:!isFF?fontColor(data['open_px'], data['preclose_px']):fontColor(data['open_px'], data['prev_settlement'])}">
            {{dot(data['open_px'])}}</span></li>
        <li>Highest <span
            :style="{color:!isFF?fontColor(data['high_px'], data['preclose_px']):fontColor(data['high_px'], data['prev_settlement'])}"
            :class="[{'bg-red':data['high_px']==1},{'bg-green':data['high_px']==2},{'bg-none':data['high_px']==0}]"
          >
            {{dot(data['high_px'])}}</span></li>
        <li v-if="showArr[4]">今结 <span :style="{color:fontColor(data['settlement'], data['prev_settlement'])}">{{dot(data['settlement'])}}</span></li>
        <li v-if="showArr[3]">涨停 <span :style="{color:data['up_px']!='--'?'#ef4342':'#333'}">{{dot(data['up_px'])}}</span></li>
        <li v-if="showArr[5]">Amplitude <span>{{data['last_px']>0?dot(data['Amplitude'],2):'--'}}</span><span v-if="data['last_px']>0">%</span></li>
        <li v-if="showArr[6]">Volume <span>{{data['business_amount']}}</span></li>
        <li v-if="showArr[7]"><span>市盈率 </span>{{pe_rate(data['pe_rate'])}}</li>
        <li v-if="showArr[8]"><span>总市值 </span>{{data['market_value']|numFormat}}</li>
        <li v-if="showArr[9]"><span>盘后量 </span>{{data['last_px']>0?data['business_amount_am']:'--'|numFormat}}</li>
        <li v-if="showArr[10]"><span>持仓量 </span>{{data['amount']|numFormat}}</li>
      </ul>
      <ul>
        <li>Yesterday <span>{{dot(data['preclose_px'])}}</span></li>
        <li>Lowest <span
            :style="{color:!isFF?fontColor(data['low_px'], data['preclose_px']):fontColor(data['low_px'], data['prev_settlement'])}"
            :class="[{'bg-red':data['low_px']==1},{'bg-green':data['low_px']==2},{'bg-none':data['low_px']==0}]"
          >
            {{dot(data['low_px'])}}</span></li>
        <li v-if="showArr[14]">昨结 <span>{{dot(data['prev_settlement'])}}</span></li>
        <li v-if="showArr[13]">跌停 <span :style="{color:data['down_px']!='--'?'#2ab447':'#333'}">{{dot(data['down_px'])}}</span></li>
        <li v-if="showArr[15]">换手 <span>{{data['last_px']>0?dot(data['turnover_ratio'],2):'--'}}</span><span v-if="data['last_px']>0">%</span></li>
        <li v-if="showArr[16]">Turnover ratio <span :style="{color:fontColor(data['vol_ratio'], 1)}">{{data['last_px']>0?dot(data['vol_ratio'],2):'--'}}</span></li>
        <li v-if="showArr[17]">Turnover <span>{{data['business_balance']|numFormat}}</span></li>
        <li v-if="showArr[18]"><span>市净率 </span>{{pe_rate(data['dyn_pb_rate'])}}</li>
        <li v-if="showArr[19]"><span>流通市值 </span>{{data['circulation_value']|numFormat}}</li>
        <li v-if="showArr[20]"><span>盘后额 </span>{{data['last_px']>0?data['business_balance_am']:'--'|numFormat}}</li>
        <li v-if="showArr[21]"><span>日增仓 </span>{{data['amount']!=='--'?data['amount']-data['prev_amount']:data['amount']|numFormat}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { numFormat } from '../script/filters.js'
import { TradVolume } from '../../util/index.js'
import { fontColor, isOneOf } from '../../controller/util.js'
import { OpenAPI } from '../../controller/datamanager/api';
import getToFixed from '../../util/vueFunction'
export default {
  name: "handicapGeneral",
  props: {
    // 产品代码
    prod_code: {
      type: String,
      default: ""
    },
    // 请求间隔
    throttle: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      timer: null,
      data: {},
      indexData: [],
      type_code: '', // 盘口类型
      trade_status: ['OCALL', 'TRADE'],
      fields: [ //沪深市值
        'hq_type_code',
        'trade_status', // 市场状态
        'prod_name', // 产品名称
        'prod_code', // 产品代码
        'data_timestamp', // 最后更新时间
        'last_px', // 最新价
        'px_change', // 价格涨跌
        'px_change_rate', // 涨跌幅
        'preclose_px', // 昨收价
        'open_px', // 开盘价
        'high_px', // 最高价
        'low_px', // 最低价
        'Amplitude', // 振幅
        'vol_ratio', // 量比
        'turnover_ratio', // 换手率
        'business_amount', // 外盘成交量
        'business_balance', // 成交金额
        'market_date', //  市场时间
        'up_px', // 涨停
        'down_px', // 涨停
        'pe_rate', // 市盈率
        'dyn_pb_rate', // 市净率
        'market_value', // 总市值
        'circulation_value', // 流通市值
        'business_amount_am', // 盘后成交量
        'business_balance_am', // 盘后成交额
        'settlement', // 今结
        'prev_settlement', // 昨结
        'amount', // 持仓量
        'prev_amount' // 昨持仓
      ],
      isFF: false, // 是否期货/期权
      decNum: 0, // 小数位
      showArr: [], // 字段显示
      numberFormat: function(number, ratioFixed = 2) {
        // if (!isValidNumber(number) || !isValidNumber(ratioFixed)) {
        //   throw new Error(`${number} or ${ratioFixed} is not a valid number`);
        // }
        if (Math.abs(number) > 1000000000000) {
          return (Math.abs(number) / 1000000000000).toFixed(ratioFixed) + 'trillion';
        } else if (number > 100000000) {
          return number > 0 ? (number / 100000000).toFixed(ratioFixed) + 'mn' : (number / 100000000).toFixed(ratioFixed) + 'mn'
        } else if (Math.abs(number) > 10000) {
          return number > 0 ? (number / 10000).toFixed(ratioFixed) + 'ten thousand' : (number / 10000).toFixed(ratioFixed) + 'ten thousand'
        } else {
          return number.toFixed(0);
        }
      },
      // numFormat: function(params) {
      //   if (params && typeof params === 'number') {
      //     if (Math.abs(params) >= 1000000000000) {
      //       return (params / 1000000000000).toFixed(2) + 'trillion'
      //     } else if (Math.abs(params) >= 100000000 && Math.abs(params) < 1000000000000) {
      //       return (params / 100000000).toFixed(2) + 'mn'
      //     } else if (Math.abs(params) >= 10000 && Math.abs(params) < 100000000) {
      //       return (params / 10000).toFixed(2) + 'ten thousand'
      //     } else {
      //       return params
      //     }
      //   } else {
      //     return params
      //   }
      // },
    };
  },
  filters: {
    numFormat: function(params) {
        if (params && typeof params === 'number') {
          if (Math.abs(params) >= 1000000000000) {
            return (params / 1000000000000).toFixed(2) + 'trillion'
          } else if (Math.abs(params) >= 100000000 && Math.abs(params) < 1000000000000) {
            return (params / 100000000).toFixed(2) + 'mn'
          } else if (Math.abs(params) >= 10000 && Math.abs(params) < 100000000) {
            return (params / 10000).toFixed(2) + 'ten thousand'
          } else {
            return params
          }
        } else {
          return params
        }
      },
  },
  created() {
    // 盘口小数位
    getToFixed.getToFixed(this.prod_code).then(data => { this.decNum = data })
    // 盘口类型
    this.getType(this.prod_code, 'hq_type_code')
    // 盘口元素显示控制
    for (let i = 1; i <= 21; i++) {
      this.showArr.push(false)
    }
  },
  methods: {
    // 板块类型
    getType(code, fields) {
      let params = { code, fields }
      OpenAPI.real(params).then(res => {
        this.indexData = res[code];
        this.type_code = this.indexData[2]
        // 期权/期货
        this.isFF = isOneOf(['CCFX', 'XSHO', 'XSGE', 'XDCE', 'XZCE', 'SHGE'], this.type_code)
        // 1今开,  2最高,  3涨停,4今结, 5振幅,        6成交量,  7市盈率, 8总市值,  9盘后量,10持仓量
        // 11昨收,12最低,13跌停,14昨结,15换手,16量比,17成交额,18市净率,19流通市值,20盘后额,21日增仓
        let indexs = []
        // A/B股/新三板
        // if (['ESA','ESB','JJZR','ZSZR','LWTS'].some(item => this.type_code.includes(item))) {
        if (isOneOf(['ESA', 'ESB', 'JJZR', 'ZSZR', 'LWTS'], this.type_code)) {
          indexs = [3, 13, 5, 15, 6, 17, 7, 18, 8, 19]
        }
        // 科创板
        else if (isOneOf(['KSH'], this.type_code)) {
          indexs = [3, 13, 5, 15, 6, 17, 7, 18, 8, 19, 9, 20]
        }
        // 港股
        else if (isOneOf(['XHKG-M', 'XHKG-G', 'XHKG-N'], this.type_code)) {
          indexs = [5, 16, 6, 17, 7, 18, 8, 19]
        }
        // 期货/期权
        else if (isOneOf(['CCFX', 'XSHO', 'XSGE', 'XDCE', 'XZCE', 'SHGE'], this.type_code)) {
          indexs = [3, 13, 4, 14, 5, 16, 6, 17, 10, 21]
        }
        // 指数/其他
        else {
          indexs = [5, 16, 6, 17]
        }
        indexs.map(item => {
          this.showArr[item] = true
        })
      }).then(() => {
        this.getIndexDataInterval(this.prod_code, this.fields.join(','))
        if (this.throttle > 0) {
          this.timer = setInterval(() => {
            this.getIndexDataInterval(this.prod_code, this.fields.join(','))
          }, 10000);
        }
      });
    },
    // 行情数据
    getIndexDataInterval(code, fields) {
      let params = { code, fields };
      OpenAPI.real(params).then(res => {
        let data = res[code]
        let fields = res['fields']
        let temp = {}
        // 为0不格式化
        let ignoreList = [
          'last_px', // 最新价
          'px_change', //涨跌额
          'px_change_rate', //涨跌幅
          'Amplitude', //振幅
          'turnover_ratio', // 换手
          'vol_ratio', // 量比
          'business_amount_am', // 盘后量
          'business_balance_am' // 盘后额
        ]
        fields.map((item, index) => {
          temp[item] = data[index]
          // temp[item] = 0
          // temp['last_px'] = 12
          if (temp[item] === 0 && !ignoreList.some(ignore => ignore === item)) {
            temp[item] = '--'
          }
        })
        this.zeroFmt(temp)
        this.data = temp
      });
    },
    // 小数点
    dot(params, num) {
      if (typeof params === 'number') {
        if (num) {
          return params.toFixed(num)
        } else {
          return params.toFixed(this.decNum)
        }
      } else {
        return params
      }
    },
    // 后台0格式化
    zeroFmt(temp) {
      if (typeof temp['business_amount'] === 'number') {
        temp['business_amount'] = TradVolume(temp['business_amount'], this.prod_code, temp['shares_per_hand'])
      }
      if (temp['last_px'] > 0 && temp['Amplitude'] === 0 && temp['turnover_ratio'] === 0) {
        let ignore = ['business_amount', 'business_balance', 'amount', 'prev_amount']
        ignore.map(item => {
          temp[item] = 0
        })
      }
      return temp
    },
    // 市盈率市净率
    pe_rate(params) {
      if (typeof params === 'number') {
        if (params < 0) {
          return '亏损'
        } else {
          return params.toFixed(2)
        }
      } else {
        return params
      }
    },
    // 字体颜色
    fontColor(current, compare) {
      return fontColor(current, compare)
    }
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        // 背景颜色
        for (const key in newVal) {
          for (const key1 in oldVal) {
            if (typeof newVal[key] === 'number') {
              if (newVal[key] > oldVal[key]) {
                this.data[key + '_bgc'] = 1
              }
              else if (newVal[key] < oldVal[key]) {
                this.data[key + '_bgc'] = 2
              }
              else {
                this.data[key + '_bgc'] = 0
              }
            }
          }
        }
        setTimeout(() => {
          for (const key in newVal) {
            if (typeof newVal[key + '_bgc'] === 'number') {
              this.data[key + '_bgc'] = 0
            }
          }
        }, 2000);
      }
    },
    inmediate: true,
    deep: true
  },
  // filters: {
  //   // 全局过滤器
  //   // dateFormat日期
  //   // timeFormat时间
  // },
  destroyed() {
    clearInterval(this.timer)
  }
};
</script>

<style scoped>
/* 根据不同屏适配股票名称显示长度 */
@media screen and (min-width: 1700px) {
  .left-info .base-info .title {
    max-width: 200px;
  }
}
@media screen and (max-width: 1700px) {
  .left-info .base-info .title {
    max-width: 150px;
  }
}
@media screen and (max-width: 1420px) {
  .left-info .base-info .title {
    max-width: 109px;
  }
}
* {
  padding: 0;
  margin: 0;
  font-size: 14px;
  list-style-type: none;
}
.handicap-box {
  /* min-width: 1200px; */
  overflow: 0 auto;
  height: 68px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #e8f1ff;
}
ul li {
  text-align: left;
  /* min-width: 110px; */
}
.left-info {
  display: flex;
  width: 23%;
  justify-content: space-around;
}
.base-info > li {
  width: 100%;
  text-align: left;
  line-height: 26px;
}
.base-info > li:first-child {
  padding-top: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
}
.base-info .title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
/* .px-change-info {
  padding-right: 10px;
} */
.px-change-info > li {
  text-align: center;
  line-height: 26px;
}
.px-change-info > li > span {
  padding: 0 5px;
  border-radius: 3px;
}
.px-change-info > li:first-child > span {
  font-size: 24px;
}
.px-change-info > li:first-child {
  font-size: 18px;
  font-weight: 700;
  padding-top: 6px;
}
.px-change-info .px-change {
  margin-right: 12px;
}
.up {
  color: red;
}
.down {
  color: #2ab447;
}
.up_arrow {
  display: inline-block;
  border: 5px solid;
  border-color: transparent transparent red;
  vertical-align: super;
}
.down_arrow {
  display: inline-block;
  border: 5px solid;
  border-color: #2ab447 transparent transparent;
}
.right-info {
  display: flex;
  flex-wrap: wrap;
  width: 77%;
  height: 55px;
  padding-top: 10px;
}
.right-info > ul > li {
  width: 100%;
  text-align: left;
  line-height: 26px;
  height: 26px;
  color: #333;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.right-info ul li:nth-child(-n + 4) {
  width: 75%;
}
.right-info ul li:nth-child(4n) {
  width: 90%;
}
/* .right-info>ul>li:nth-child(6) {
  padding-left: 20px;
} */
.right-info > ul > li:nth-child(8) {
  padding-left: 10px;
}
.right-info > ul > li > span {
  /* padding: 0 5px; */
  border-radius: 3px;
}
.right-info > ul {
  display: flex;
  width: 100%;
  justify-content: space-around;
  /* padding-right: 10px; */
}
.bg-red {
  /* background: #F9D9E4; */
  background: rgb(255, 253, 215);
}
.bg-green {
  /* background: lightgreen; */
  background: rgb(255, 253, 215);
}
.bg-none {
  background-color: #e8f1ff;
}
.indent-20 {
  text-indent: 20px;
}
.date_color {
  color: #666;
}
</style>
